import 'bootstrap/js/dist/tooltip'

$('[data-toggle="tooltip"]').tooltip();



// WEBPACK FOOTER //
// app/javascript/common/tooltip.js